// Rekordy osobiste: najlepszy czas zwyciestwa na kazdej planszy.
//
// Osobny klucz od stanu gry (persistence.ts), zeby rekordy nie zniknely przy
// zwyklym zapisie konstrukcji. "Mistrz" (parTimeSec) jest celem z danych planszy,
// a rekord to wynik gracza - bez ducha, zeby nie mozna bylo skopiowac konstrukcji.

import { safeStorage } from './persistence';

export const RECORDS_KEY = 'robot-lab.records.v1';

export type Records = Record<string, number>;

/** Wczytuje rekordy. Zwraca pusty obiekt przy braku zapisu lub uszkodzonych danych. */
export function loadRecords(storage: Storage | null = safeStorage()): Records {
  if (!storage) return {};
  let raw: string | null = null;
  try {
    raw = storage.getItem(RECORDS_KEY);
  } catch {
    return {};
  }
  if (!raw) return {};

  let parsed: unknown;
  try {
    parsed = JSON.parse(raw);
  } catch {
    return {};
  }
  if (typeof parsed !== 'object' || parsed === null) return {};

  const records: Records = {};
  for (const [id, value] of Object.entries(parsed as Record<string, unknown>)) {
    if (typeof value === 'number' && Number.isFinite(value) && value > 0) records[id] = value;
  }
  return records;
}

/**
 * Zapisuje czas zwyciestwa, jesli jest lepszy od dotychczasowego rekordu.
 * Zwraca true, gdy rekord zostal pobity.
 */
export function submitRecord(
  records: Records,
  challengeId: string,
  timeSec: number,
  storage: Storage | null = safeStorage(),
): boolean {
  if (!Number.isFinite(timeSec) || timeSec <= 0) return false;
  const current = records[challengeId];
  if (current !== undefined && current <= timeSec) return false;

  records[challengeId] = timeSec;
  if (storage) {
    try {
      storage.setItem(RECORDS_KEY, JSON.stringify(records));
    } catch {
      // brak zapisu nie jest bledem gry - rekord zostaje w pamieci sesji
    }
  }
  return true;
}

/** Usuwa rekordy (np. przycisk resetu). */
export function clearRecords(storage: Storage | null = safeStorage()): void {
  if (!storage) return;
  try {
    storage.removeItem(RECORDS_KEY);
  } catch {
    // ignorujemy
  }
}
